import { useState, useEffect } from 'react';
import _uniqueId from 'lodash/uniqueId';

const Modal = ({ id = 0, visible, children, delay = 2000, title, pixelCoords, onClose, pinned, divWindow = false }) => {
    const [on, setOn] = useState(false);
    const [modalID] = useState(_uniqueId('modal-'));

    const hideBox = () => setOn(pinned);
    const closeWindow = () => {
        setOn(false);
        if (onClose) onClose();
    };
    var time = false;

    //When content added
    useEffect(() => {
        if (!delay) {
            setOn(true);
            return;
        }
        clearTimeout(time);
        if (!pinned) return;
        setTimeout(() => {
            setOn(true); //turn on animation
            time = setTimeout(hideBox, delay);
        }, 10);
        return () => {
            clearTimeout(time);
        };
    }, []);

    useEffect(() => {
        setOn(visible); //turn on animation
        if (!delay) return;
        clearTimeout(time);
        if (!pinned) return;
        time = setTimeout(hideBox, delay);
        return () => {
            clearTimeout(time);
        };
    }, [children, visible]);

    //ΔVΔVΔ: Temprary needed for Feature title, positioning thrown off by changing div to dialog
    if (divWindow) {
        return (
            <>
                <div id={modalID} open={on} className={`modal-win ${on ? 'show' : ''} ${pinned ? 'pinned' : ''}`} style={{ top: pixelCoords[1], left: pixelCoords[0] }}>
                    {pinned && <div className="icon-close" onClick={closeWindow}></div>}
                    {title && <h3 className="win-title">{title}</h3>}
                    {/* {!title && <div className="drag-bar"></div>} */}
                    <div className="content">{children}</div>
                </div>
            </>
        );
    }

    return (
        <>
            <dialog id={modalID} open={on} className={`modal-win ${on ? 'show' : ''} ${pinned ? 'pinned' : ''}`} style={{ top: pixelCoords[1], left: pixelCoords[0] }}>
                {pinned && <div className="icon-close" onClick={closeWindow}></div>}
                {title && <h3 className="win-title">{title}</h3>}
                {!title && <div className="drag-bar"></div>}
                <div className="content">{children}</div>
            </dialog>
        </>
    );
};
export default Modal;

const ModalBackground = (props) => {
    const { visible } = props;
    return <div aria-hidden="true" className={`modal-background ${visible ? 'show' : 'hide'}`}></div>;
};
export { ModalBackground };
